import type { CustomPricingBase, CustomPricingContext } from "@classes-service-types/index.ts";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { learningServiceRequest } from "@/services/utils";
import { QUERY_KEY } from "./useGetCustomPricingList";

type CreateCustomPricingArgs = {
  data: CustomPricingBase;
};

export const useCreateCustomPricing = (
  useMutationOptions?: UseMutationOptions<CustomPricingContext, Error, CreateCustomPricingArgs>,
) => {
  const queryClient = useQueryClient();

  return useMutation<CustomPricingContext, Error, CreateCustomPricingArgs>({
    mutationFn: async ({ data }) => {
      const response: AxiosResponse<{ data: CustomPricingContext }> = await learningServiceRequest({
        method: "post",
        url: "/custom_pricing/",
        payload: { data },
      });
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
    },
    ...useMutationOptions,
  });
};
